/* eslint-disable no-console */
import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { getIn } from 'formik';

const FormikInputField = ({
  field: { ...fields },
  form: {
    touched,
    errors,
    setFieldValue,
    handleBlur,
    setFieldTouched,
    submitCount,
  },
  label,
  id,
  required,
  disabled = false,
  ...rest
}) => {
  const { name } = fields;

  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue(name, value, true);
  };
  const handleFocus = () => {
    setFieldTouched(name, true, true);
  };

  // Use getIn to properly resolve nested paths like 'orderLogistics.0.vehicleNumber'
  const isTouched = getIn(touched, name);
  const errorMsg = getIn(errors, name);
  // Show error if field was touched OR if form was submitted (submitCount > 0)
  const shouldShowError = (isTouched || submitCount > 0) && errorMsg;

  return (
    <FormGroup className="flex-grow-1">
      {label && (
        <Label
          for={id}
          className={`label-color text-nowrap ${disabled ? 'disabled' : ''}`}
        >
          {label}
          {required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
        </Label>
      )}
      <Input
        {...fields}
        onChange={handleChange}
        onFocus={handleFocus}
        invalid={Boolean(shouldShowError)}
        onBlur={handleBlur}
        disabled={disabled}
        required={required}
        {...rest}
      />

      {shouldShowError ? (
        <div className="text-danger f-12">{errorMsg}</div>
      ) : null}
    </FormGroup>
  );
};

export default FormikInputField;
